const PRODUCT_API = '/sitecore/api/ssc/isagenix/productapi/1';
const NUTRITIONALINFO_API = '/sitecore/api/ssc/isagenix/NutritionalInfoapi/1';

export async function getProducts(request) {
    return $.ajax({
        headers: {
            'Content-Type': 'application/json'
        },
        type: 'GET',
        url: `${PRODUCT_API}/getproducts`,
        contentType: 'application/json',
        dataType: 'json',
        data: request
    });
}

export async function getProductReviews(request) {
    return $.ajax({
        headers: {
            'Content-Type': 'application/json'
        },
        type: 'GET',
        url: `${PRODUCT_API}/GetProductReviews`,
        contentType: 'application/json',
        dataType: 'json',
        data: request
    });
}

export async function saveProductReview(request) {
    return $.ajax({
        type: 'POST',
        url: `${PRODUCT_API}/SaveProductReview`,
        dataType: 'json',
        data: request
    });
}

export async function getProductNutritionalInfo(request) {
    var url = `${NUTRITIONALINFO_API}/GetProductNutritionalInfo`;
    return $.ajax({
        headers: {
            'Content-Type': 'application/json'
        },
        type: 'GET',
        url: url,
        contentType: 'application/json',
        dataType: 'json',
        data: request

    });
}

export async function getProductDetailPageViewModel(request) {
    return $.ajax({
        headers: {
            'Content-Type': 'application/json'
        },
        type: 'GET',
        url: `${PRODUCT_API}/GetProductDetailPageViewModel`,
        contentType: 'application/json',
        dataType: 'json',
        data: request
    });
}

export async function getDefaultPackComponents(request) {
    return $.ajax({
        headers: {
            'Content-Type': 'application/json'
        },
        type: 'GET',
        url: `${PRODUCT_API}/GetDefaultPackComponents`,
        contentType: 'application/json',
        dataType: 'json',
        data: request
    });
}
